import { UserRole } from "../../gql/graphql";

export const isAdmin = (role?: UserRole) => role == UserRole.Admin;
